<template>
  <div>
    <v-client-table :data="sortEcheance"
                    class='mgt-10px column is-12 is-paddingless'
                    :columns="columns"
                    :options="options">
      <div slot="patrimoine" slot-scope="props">
        {{ getPatrimoine(props.row) }}
      </div>
      <div slot="typeProduit" slot-scope="props">
        <p v-for="(type, index) in getProduit(props.row)" :key="index">
          {{ props.row.lignesCommandeRegroupementLibelle.length > 1 ? type : '- ' + type }}
        </p>
      </div>
      <div slot="dateDebut" slot-scope="props">
        {{ props.row.dateDebut | formatDate }}
      </div>
      <div slot="dateFin" slot-scope="props">
        {{ props.row.dateFin | formatDate }}
      </div>
      <div slot="datePrevisionnelleFacturation" slot-scope="props">
        {{ props.row.datePrevisionnelleFacturation | formatDate }}
      </div>
      <div slot="montant" slot-scope="props" class="has-text-right">
        {{ props.row.montant | formatDevise }}
      </div>
      <div slot="commentaireFacturation" slot-scope="props" class="has-text-centered">
         <div v-if="props.row.commentaireFacturation">
          {{ props.row.commentaireFacturation }}
         </div>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import detailProduitEcheance from '@/components/commande/baf/detailProduitEcheance';
import moment from 'moment';

export default {
  name: 'childRowCommandeAFacturer',
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  methods: {
    getProduit(echeance) {
      if (echeance.lignesCommandeLibelle.length === 0) return [];
      if (echeance.lignesCommandeRegroupementLibelle.length > 1) {
        return [this.$i18n.t('commandeBaf.tab.multiProduit')];
      }
      return echeance.lignesCommandeLibelle;
    },
    getPatrimoine(echeance) {
      if (echeance.lignesCommandeRegroupementLibelle.length === 0) return '';
      if (echeance.lignesCommandeRegroupementLibelle.length > 1) {
        return this.$i18n.t('commandeBaf.tab.multiPatrimoine');
      }
      return echeance.lignesCommandeRegroupementLibelle[0];
    },
  },
  computed: {
    columns() {
      return ['patrimoine', 'typeProduit', 'dateDebut', 'dateFin', 'datePrevisionnelleFacturation', 'montant', 'commentaireFacturation'];
    },
    hasMultiProduitOrPatrimoine() {
      return this.data.echeancesLignes.some((commande) => {
        return commande.lignesCommandeRegroupementLibelle.length > 1;
      });
    },
    sortEcheance() {
      const echeance = cloneDeep(this.data.echeancesLignes);
      return echeance.sort((a, b) => {
        if (moment(a.datePrevisionnelleFacturation)
          .isAfter(moment(b.datePrevisionnelleFacturation))) return 1;
        if (moment(a.datePrevisionnelleFacturation)
          .isSame(moment(b.datePrevisionnelleFacturation))) return 0;
        return -1;
      });
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDebut: this.$i18n.t('listeCommandeAFacturer.table.childrow.dateDebut'),
          dateFin: this.$i18n.t('listeCommandeAFacturer.table.childrow.dateFin'),
          typeProduit: this.$i18n.t('listeCommandeAFacturer.table.childrow.typeProduit'),
          patrimoine: this.$i18n.t('listeCommandeAFacturer.table.childrow.patrimoine'),
          datePrevisionnelleFacturation: this.$i18n.t('listeCommandeAFacturer.table.childrow.dateFacturation'),
          montant: this.$i18n.t('listeCommandeAFacturer.table.childrow.montantHt'),
          commentaireFacturation: this.$i18n.t('listeCommandeAFacturer.table.childrow.commentaireFacturation'),
        },
        columnsClasses: {
          patrimoine: 'width-535',
          commentaireFacturation: 'colonneSelected',
        },
        childRow: this.hasMultiProduitOrPatrimoine ? detailProduitEcheance : null,
        rowClassCallback: ((row) => {
          if (row.lignesCommandeRegroupementLibelle.length <= 1
            && (row.commentaireFacturation === null || row.commentaireFacturation === '')) {
            return 'hideChildToggler disableChildRowClick';
          }
          return 'activeChildRowClick';
        }),
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        sortable: ['dateDebut', 'dateFin', 'datePrevisionnelleFacturation', 'montant'],
      };
    },
  },
};
</script>

<style scoped>

</style>
